<h2 mat-dialog-title>{{ 'LABEL.ADVANCED_SEARCH' | translate }}</h2>

<div mat-dialog-content>
  <form [formGroup]="form" fxLayout="row wrap" fxLayoutGap="8px grid">
    <mat-form-field appearance="outline" fxFlex="50">
      <mat-label>{{ 'LABEL.name' | translate }}</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="50">
      <mat-label>{{ 'LABEL.surname' | translate }}</mat-label>
      <input matInput formControlName="surname" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>{{ 'LABEL.legalEntity' | translate }}</mat-label>
      <input matInput formControlName="legalEntity" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="50">
      <mat-label>{{ 'LABEL.telephone1' | translate }}</mat-label>
      <input matInput formControlName="telephone1" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="50">
      <mat-label>{{ 'LABEL.telephone2' | translate }}</mat-label>
      <input matInput formControlName="telephone2" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>{{ 'LABEL.email' | translate }}</mat-label>
      <input matInput formControlName="email" type="email" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>{{ 'LABEL.streetName' | translate }}</mat-label>
      <input matInput formControlName="streetName" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="50">
      <mat-label>{{ 'LABEL.city' | translate }}</mat-label>
      <input matInput formControlName="city" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="50">
      <mat-label>{{ 'LABEL.state' | translate }}</mat-label>
      <input matInput formControlName="state" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>{{ 'LABEL.responsible' | translate }}</mat-label>
      <input matInput formControlName="responsible" />
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ 'LABEL.CANCEL' | translate }}</button>
  <button mat-raised-button color="primary" (click)="search()">{{ 'LABEL.SEARCH' | translate }}</button>
</div>
